import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
  toggleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 430,
    paddingLeft: 30,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: 12,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      paddingLeft: 0,
    },
  },
  toggleWrapper: {
    minWidth: '48%',
    width: '48%',
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      width: '100%',
    },
  },
  labelContainer: {},
  label: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '19px',
    color: theme.palette.common.black,
  },
  sublabel: {
    fontSize: 16,
    lineHeight: '19px',
    color: theme.palette.secondary.dark,
  },
  durationContainer: {},
  field: {
    width: 120,
    height: 40,
    '& input': {
      padding: '14px 8px',
      paddingRight: 0,
    },
    '& .flatsy-text-field__check': {
      display: 'none',
    },
  },
}))
